// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__1XVCp","footer":"ModalFilter_footer__2tnIp"};